// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// The web-app service worker (app/views/pwa/service-worker.js, installability
// only). Registered from the bundle rather than an inline <script>: the content
// security policy allows scripts from our own files only, and blocked the
// inline registration on every page.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js").catch(() => {})
}
